import { render, staticRenderFns } from "./PreferencesEmail.vue?vue&type=template&id=d70ef0ce"
import script from "./PreferencesEmail.vue?vue&type=script&lang=js"
export * from "./PreferencesEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports